export const defaultState = () => {
  const defaultFilter = "modified";
  const limit = 5;
  return {
    search: {
      query: "",
      pages: [],
      templates: [],
      faqs: [],
      loading: false,
    },

    pages: {
      subpages: {
        group_query: 0,
        query: "",
        fetched: false,
        list: [],
        filter: defaultFilter,
        reverse: false,
        pagination: {
          page: 1,
          limit: limit
        },
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      },
      articlepages: {
        group_query: 0,
        query: "",
        fetched: false,
        list: [],
        filter: defaultFilter,
        reverse: false,
        pagination: {
          page: 1,
          limit: limit
        },
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      },
      homepages: {
        group_query: 0,
        query: "",
        fetched: false,
        list: [],
        filter: defaultFilter,
        reverse: false,
        pagination: {
          page: 1,
          limit: limit
        },
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      },
      productpages: {
        group_query: 0,
        query: "",
        fetched: false,
        list: [],
        filter: defaultFilter,
        reverse: false,
        pagination: {
          page: 1,
          limit: limit
        },
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      },
      collectionpages: {
        group_query: 0,
        query: "",
        fetched: false,
        list: [],
        filter: defaultFilter,
        reverse: false,
        pagination: {
          page: 1,
          limit: limit
        },
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      },
      recentPage: {
        query: "",
        list: [],
        fetched: false,
        status: {
          loading: false,
          success: false,
          error: false
        },
        statusList: {
          loading: false,
          success: false,
          error: false
        }
      }
    },
    assignments: {
      productpages: {
        fetched: false,
        fetchedAssign: false,
        list: [],
        total: 0,
        isAssignAll: false
      },
      collectionpages: {
        fetched: false,
        fetchedAssign: false,
        list: [],
        total: 0,
        isAssignAll: false
      },
    },
    templates: {
      fetched: false,
      list: [],
      tags: "",
      statusList: {
        loading: false,
        success: false,
        error: false
      },
      status: {
        loading: false,
        success: false,
        error: false
      }
    },
    abTestingBlockModal: false,
    loadingFrame: false,
    loadingFrameType: "rendering_loading", // create_new_page || rendering_loading
    defaultPageName: "",
    publishedPageCount: 0,
    publishedPage: {
      productpages: 0,
      articlepages: 0,
      collectionpages: 0
    }
  };
};

const state = defaultState();

export default state;
